module.exports = __webpack_public_path__ + "static/media/WeddingCakes.0b919e73.png";